import { render, staticRenderFns } from "./PosSelectors.template.vue?vue&type=template&id=a9976610&scoped=true&"
var script = {}
import style0 from "./PosSelectors.template.vue?vue&type=style&index=0&id=a9976610&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9976610",
  null
  
)

export default component.exports